import classNames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import { ChangeEvent, FC, useCallback } from 'react';

type OwnProps = {
  hasConfirmed: boolean;
  className?: string;
  disabled?: boolean;
  onHasConfirmedChanged: (value: boolean) => void;
};

export const PublicOfferingDisclaimer: FC<OwnProps> = ({
  hasConfirmed,
  className,
  disabled,
  onHasConfirmedChanged,
}) => {
  const onHasFrenchPublicOfferingConfirmedChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onHasConfirmedChanged(e.target.checked);
    },
    [onHasConfirmedChanged],
  );

  return (
    <div className={classNames('form-check', className)}>
      <input
        className="form-check-input"
        type="checkbox"
        id="accept-public-offering-legal-warning"
        checked={hasConfirmed}
        disabled={disabled}
        data-e2e="accept-public-offering-legal-warning"
        onChange={onHasFrenchPublicOfferingConfirmedChange}
      />
      <label className="form-check-label" htmlFor="accept-public-offering-legal-warning">
        <FormattedMessage id="productModification.sidePanel.publicOfferingConfirmation"></FormattedMessage>
      </label>
    </div>
  );
};

PublicOfferingDisclaimer.displayName = 'PublicOfferingDisclaimer';
